export default __webpack_public_path__ + "static/Entenda0144-7487a73b817baa3457ec2e6327bb70c2.jpg";